import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Compass, DoorOpen, HandPlatter, ReceiptText } from 'lucide-react';
import routes from '@/constants/routes';
import { totalSelector } from '@/features/order/slice';
import SummaryBox from '@/features/order/Order';
import { Section } from '@/features/dine-in-flow/Canvas';

interface Props {
  sections?: Section[];
}
const MenuBottomNavigation = ({ sections = [] }: Props) => {
  const total = useSelector(totalSelector);
  const { organizationAlias } = useParams<{ organizationAlias: string }>();
  
  const [value, setValue] = useState(1);
  const [openOrder, setOpenOrder] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpenOrder = () => {
    setOpenOrder(!openOrder);
  };

  const handleOpenIndex = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseIndex = () => {
    setAnchorEl(null);
  };

  const scroll = (target: string) => {
    const element = document.getElementById(`section-${target}`);

    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        height: '70px',
        zIndex: 100,
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_event, newValue) => {
          setValue(newValue);
        }}
        sx={{
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          height: '100%',
        }}
      >
        <BottomNavigationAction
          label="Inicio"
          icon={<DoorOpen />}
          component={Link}
          to={routes.organizations.root.replace(':organizationAlias', organizationAlias ?? '')}
          sx={{
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.75rem',
            },
          }}
        />
        <BottomNavigationAction
          label="Menús"
          icon={<HandPlatter />}
          component={Link}
          to={routes.organizations.menu.main.replace(':organizationAlias', organizationAlias ?? '')
          }
          sx={{
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.75rem',
            },
          }}
        />
        <BottomNavigationAction
          label="Cuenta"
          icon={
            <Badge variant={total ? 'dot' : 'standard'} color="primary">
              <ReceiptText />
            </Badge>
          }
          onClick={handleOpenOrder}
          sx={{
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.85rem',
            },
          }}
        />
        {sections?.length ? (
          <BottomNavigationAction
            label="Indice"
            icon={<Compass />}
            onClick={handleOpenIndex}
            sx={{
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.85rem',
              },
            }}
          />
        ) : null}
      </BottomNavigation>
      <SummaryBox isOpen={openOrder} onClose={() => setOpenOrder(false)} />
      {/* Index */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseIndex}>
        {sections.map((section) => (
          <MenuItem key={section.slug} onClick={() => scroll(section.slug)}>
            {section.label}
          </MenuItem>
        ))}
      </Menu>
    </Paper>
  );
};

export default MenuBottomNavigation;
